import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-old-indent',
  templateUrl: './old-indent.component.html',
  styleUrls: ['./old-indent.component.scss']
})
export class OldIndentComponent implements OnInit {

  min_date = new Date('2020-04-01').toISOString().split('T')[0];
  max_date = new Date().toISOString().split('T')[0];
  session_list: any;
  selected_date: any;
  selected_session_id: any;
  overall_indent_status: any;
  indent_prepared_route_ids: any;
  res_data: any;
  overall_indent: any;
  product_types: any;
  booth_types: any;
  product_names: any = [];
  master_data_loaded: boolean = false;
  route_datas_loaded: boolean = true;
  route_wise_indent: any;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 100;
  temp_route_dict: any;
  title: any;

  constructor(private httpservice: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;

    this.httpservice.getSession().subscribe((sessions: []) => {
      this.session_list = sessions;
      console.log(this.session_list);
    }, (error) => {
      console.log(error);
    });
  }

  checkDisable() {
    if (this.selected_session_id == null || this.selected_date == null) {
      return true;
    } else {
      return false;
    }
  }

  getClicked() {
    let data_dict = {
      'selected_date': this.selected_date,
      'session_id': this.selected_session_id
    };
    console.log(data_dict);
    this.getOverallIndentData();
    this.getIndentRouteWiseData();
    // this.getPreparedIndentRouteIds();
    this.serveTempRouteDetails();
  }

  getOverallIndentData() {
    console.log();
    const data_dict = {
      'session_id': this.selected_session_id,
      'date': this.selected_date
    };

    this.httpservice.checkForOverallRouteCloseForOldIndent(data_dict).subscribe((data: number) => {
      console.log(data);
      this.overall_indent_status = data['status']
      this.indent_prepared_route_ids = data['route_trace']
      console.log(this.indent_prepared_route_ids);
    }, (error) => {
      console.error(error);
    });
    this.master_data_loaded = false;
    this.httpservice.getOverallIndentDataForOldIndent(data_dict).subscribe((indent_data) => {
      console.log(indent_data);
      this.res_data = indent_data;
      this.overall_indent = indent_data['overall_data'];
      this.product_types = Object.keys(this.res_data['product_group_wise'])
      this.booth_types = Object.keys(indent_data['booth_types'])
      const product_names_ids = Object.keys(indent_data['overall_data']['products']);
      product_names_ids.forEach(element => {
        this.product_names.push(indent_data['overall_data']['products'][element]['name'])
      });
      console.log(this.product_names);
      this.master_data_loaded = true;
    }, (error) => {
      this.master_data_loaded = false;
      console.log(error);
    });
  }

  calculate_percent(ordered, all) {
    let a = (ordered / all) * 100;
    return a.toFixed(2);
  }


  getSumDisplay(sum) {
    if (sum === null) {
      return 0;
    } else if (sum === 0) {
      return 0;
    } else {
      return sum;
    }
  }

  downloadOverallIndent() {
    const data_dict = {
      'session_id': this.selected_session_id,
      'date': this.selected_date
    };
    this.httpservice.getOverallPdfForOldIndent(data_dict).subscribe((data) => {
      console.log(data);
      if (data['status']) {
        // this.overall_indent_pdf = data;
        const linkSource = 'data:application/pdf;base64,' + data['pdf_document'];
        const downloadLink = document.createElement("a");
        let session_name = 'Morning';
        if (this.selected_session_id === 2) {
          session_name = 'Evening';
        }
        const fileName = 'overall' + '_' + this.selected_date + '-' + session_name + ".pdf";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        alert('Overall route is not closed');
      }
    }, (error) => {
      console.error(error);
      alert('File Not Found');
    });
  }

  getIndentRouteWiseData() {
    const data = {
      'session_id': this.selected_session_id,
      'date': this.selected_date
    };
    this.route_datas_loaded = false;
    this.httpservice.getIndentRouteWiseDataForOldindent(data).subscribe((res_data: []) => {
      console.log(res_data);
      this.route_wise_indent = res_data;
      this.route_datas_loaded = true;
    }, (error) => {
      console.log(error);
      this.route_wise_indent = [];
      this.route_datas_loaded = true;
    });
  }

  serveTempRouteDetails() {
    const data = {
      'session_id': this.selected_session_id,
      'date': this.selected_date
    };
    this.httpservice.serveTempRouteDetailsForOldIndent(data).subscribe((data) => {
      console.log(data);
      this.temp_route_dict = data;
    }, (error) => {
      console.error(error);
    });
  }

  showPdf(route_id) {
    console.log('pdf is not locally');
    const data = {
      session_id: this.selected_session_id,
      route_id: route_id,
      date: this.selected_date
    };
    this.httpservice.getIndentPdfForOldIndent(data).subscribe((data) => {
      console.log(data)
      // this.route_indent_dict[route_id]['pdf'] = data['pdf']
      if (data['status']) {
        this.indent_prepared_route_ids[route_id] = 3;
        const linkSource = 'data:application/pdf;base64,' + data['pdf'];
        const downloadLink = document.createElement("a");
        let session_name = 'Morning';
        if (this.selected_session_id === 2) {
          session_name = 'Evening';
        }
        const fileName = route_id + '_' + this.selected_date + '-' + session_name + ".pdf";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        alert('Route is not closed');
      }
    }, (error) => {
      console.error(error);
      alert('File Not Found');
    });

  }

  ngOnInit() {
  }

}
